// El «bip» de Turbo · En vivo, con un solo AudioContext para toda la
// pantalla. Antes se creaba uno por aviso: sin un toque del usuario el
// navegador lo dejaba suspendido, no sonaba, su onended nunca corría (quedaba
// uno colgado por aviso) y el botón decía «Sonido activado» igual.
//
// El navegador no deja sonar hasta que el usuario toca la página, así que
// después de recargar hace falta un toque: `estadoSonido()` dice la verdad
// para que la pantalla lo pida, y `desbloquearSonido()` va en ese toque.

export type EstadoSonido = "listo" | "bloqueado" | "sin-soporte";

let ctx: AudioContext | null = null;

function contexto(): AudioContext | null {
  if (ctx) return ctx;
  const Ctx = (window as any).AudioContext || (window as any).webkitAudioContext;
  if (!Ctx) return null;
  try { ctx = new Ctx(); } catch { ctx = null; }
  return ctx;
}

export function estadoSonido(): EstadoSonido {
  const c = contexto();
  if (!c) return "sin-soporte";
  return c.state === "running" ? "listo" : "bloqueado";
}

// Va dentro de un toque del usuario (clic, pointerdown): ahí el navegador
// deja arrancar el audio.
export async function desbloquearSonido(): Promise<EstadoSonido> {
  const c = contexto();
  if (!c) return "sin-soporte";
  try { await c.resume(); } catch { /* sigue bloqueado */ }
  return estadoSonido();
}

// Un «bip» corto. Si el navegador todavía no deja sonar, no se encola (los
// avisos viejos sonarían todos juntos al habilitarlo): devuelve "bloqueado"
// para que la pantalla lo diga.
export function bip(): EstadoSonido {
  const c = contexto();
  if (!c) return "sin-soporte";
  if (c.state !== "running") { c.resume().catch(() => {}); return "bloqueado"; }
  try {
    const o = c.createOscillator(); const g = c.createGain();
    o.type = "sine"; o.frequency.value = 880; g.gain.value = 0.08; o.connect(g); g.connect(c.destination);
    o.start(); o.frequency.setValueAtTime(1175, c.currentTime + 0.12); o.stop(c.currentTime + 0.25);
  } catch { /* sin sonido */ }
  return "listo";
}
